import _instanceof from "@swc/helpers/src/_instanceof.mjs";
import regeneratorRuntime from "/home/vsts/work/1/s/node_modules/next/dist/compiled/regenerator-runtime/runtime.js";
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import ExportButton from "@components/export-button";
import { exportToFile, getExportToFileData, getExportToFileStatus, getPowerBIAccessToken } from "@queries/powerbi-reports";
import { getAuthToken } from "@utils/services/auth";
import download from "downloadjs";
import React, { useEffect, useRef, useState } from "react";
var __awaiter = this && this.__awaiter || function(thisArg, _arguments, P, generator) {
    var adopt = function adopt(value) {
        return _instanceof(value, P) ? value : new P(function(resolve) {
            resolve(value);
        });
    };
    return new (P || (P = Promise))(function(resolve, reject) {
        var fulfilled = function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        };
        var rejected = function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        };
        var step = function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        };
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var ExportProfile = function(param) {
    var printReportConfig = param.printReportConfig;
    var ref = useState(false), isProcessing = ref[0], setIsProcessing = ref[1];
    var ref1 = useState(false), isDone = ref1[0], setIsDone = ref1[1];
    var ref2 = useState(null), exportId = ref2[0], setExportId = ref2[1];
    var ref3 = useState(0), progress = ref3[0], setProgress = ref3[1];
    var timerRef = useRef(null);
    var ref4 = useState(null), token = ref4[0], setToken = ref4[1];
    useEffect(function() {
        getAuthToken().then(function(token) {
            getPowerBIAccessToken(token).then(function(param) {
                var data = param.data;
                setToken(data);
            });
        });
    }, []);
    useEffect(function() {
        var ref = printReportConfig !== null && printReportConfig !== void 0 ? printReportConfig : {}, workspaceId = ref.workspaceId, reportId = ref.reportId;
        if (isProcessing && exportId) {
            timerRef.current = setInterval(function() {
                getExportToFileStatus(reportId, workspaceId, exportId, token).then(function(response) {
                    var _data = response.data, status = _data.status, percentComplete = _data.percentComplete;
                    setProgress(percentComplete);
                    if (status === "Succeeded") {
                        setIsDone(true);
                        clearInterval(timerRef.current);
                        setIsProcessing(false);
                    }
                });
            }, 5000);
        }
    }, [
        exportId,
        isProcessing,
        printReportConfig,
        token
    ]);
    useEffect(function() {
        var ref = printReportConfig !== null && printReportConfig !== void 0 ? printReportConfig : {}, workspaceId = ref.workspaceId, reportId = ref.reportId, fileName = ref.fileName;
        if (isDone) {
            getExportToFileData(reportId, workspaceId, exportId, token).then(function(response) {
                return __awaiter(void 0, void 0, void 0, regeneratorRuntime.mark(function _callee() {
                    return regeneratorRuntime.wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                download(response.data, fileName, "application/pdf");
                                setIsDone(false);
                            case 2:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                }));
            });
        }
    }, [
        exportId,
        isDone,
        printReportConfig,
        token
    ]);
    var exportReport = function() {
        var ref = printReportConfig !== null && printReportConfig !== void 0 ? printReportConfig : {}, workspaceId = ref.workspaceId, reportId = ref.reportId, pages = ref.pages, filter = ref.filter, profileName = ref.profileName;
        setIsProcessing(true);
        exportToFile(reportId, workspaceId, token, pages, filter, profileName).then(function(response) {
            setExportId(response.data.id);
        });
    };
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: printReportConfig.showExportButton && /*#__PURE__*/ _jsx(ExportButton, {
            exportReport: exportReport,
            isProcessing: isProcessing,
            progress: progress,
            token: token
        })
    });
};
export default ExportProfile;
